
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { getCombinedProjectUsers } from '@/helpers/getCombinedProjectUsers';
import type { CombinedUser } from '@/helpers/getCombinedProjectUsers';
import { isDesktop } from '@/helpers/isDesktop';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';

@Component({
    name: 'FormProjectUserPicker',
})
export default class FormProjectUserPicker extends Vue {
    @Model('input', {
        required: true,
    })
    private user: CombinedUser;

    @Prop({
        required: false,
        default: () => [],
    })
    private availableUsers: CombinedUser[];

    @Prop({
        required: true,
    })
    private projectId: number;

    @Prop({
        required: false,
        default: false,
    })
    private disabled: boolean;

    private defaultUsers: CombinedUser[] = [];

    private isDesktop = isDesktop();

    @Getter('project/selectedProject') private selectedProject: Project;

    mounted() {
        if (this.availableUsers.length === 0) {
            this.loadOptions();
        }
    }

    loadOptions() {
        this.defaultUsers = getCombinedProjectUsers(this.selectedProject);
    }

    get available() {
        return this.availableUsers.length > 0 ? this.availableUsers : this.defaultUsers;
    }

    get selected() {
        return this.user;
    }

    select(value) {
        this.$emit('input', value);
    }
}
